import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Video } from './types'

export const VIDEOS_QUERY: TypedDocumentNode<
  { videos: Video[] },
  { clientId: string; applicationId: string; search?: string; limit?: number; offset?: number }
> = gql`
  query Videos($clientId: ID!, $applicationId: ID!, $search: String, $limit: Int, $offset: Int) {
    videos(clientId: $clientId, applicationId: $applicationId, search: $search, limit: $limit, offset: $offset) {
      id client_id application_id playlist_id name embedded_link observations live local_live live_hours live_timeout synchronized_at created_at updated_at
    }
  }
`

export const VIDEO_QUERY: TypedDocumentNode<{ video: Video | null }, { id: string }> = gql`
  query Video($id: ID!) {
    video(id: $id) {
      id client_id application_id playlist_id name embedded_link observations live local_live live_hours live_timeout synchronized_at created_at updated_at
    }
  }
`
